import { createFileRoute } from "@tanstack/react-router";
import Projects from "@/pages/Projects";
import { seo, breadcrumbSchema } from "@/lib/seo";

export const Route = createFileRoute("/_site/projects/")({
  head: () =>
    seo({
      title: "Recent Roofing & Siding Projects in Minnesota",
      description:
        "Browse photos of recent Cedar Creek Construction roofing, LP SmartSide siding, and gutter projects across Blaine, Ham Lake, Brooklyn Park, and the Twin Cities.",
      path: "/projects",
      jsonLd: breadcrumbSchema([
        { name: "Home", path: "/" },
        { name: "Projects", path: "/projects" },
      ]),
    }),
  component: Projects,
});
